import { render, staticRenderFns } from "./SpadPD_Items.vue?vue&type=template&id=747f384d"
import script from "./SpadPD_Items.vue?vue&type=script&lang=js"
export * from "./SpadPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports